
(function(){

  const page =
    document.querySelector('.aw-industry-page');

  if (!page || page.dataset.awReady === 'true') {
    return;
  }

  page.dataset.awReady = 'true';


  /* ========================================================
     BUILD MOBILE PACKAGE CONTENT
     FROM DESKTOP PACKAGE DATA
  ======================================================== */

  const mounts =
    page.querySelectorAll('[data-mobile-mount]');


  mounts.forEach(function(mount){

    const industry =
      mount.getAttribute('data-mobile-mount');

    const source =
      page.querySelector(
        '[data-package-source="' +
        industry +
        '"] .aw-package-grid'
      );

    if (!source) {
      return;
    }

    const clone =
      source.cloneNode(true);


    /*
      Growth is selected by default.
    */

    clone
      .querySelectorAll('[data-tier-card]')
      .forEach(function(card){

        const tier =
          card.getAttribute('data-tier-card');

        card.classList.toggle(
          'is-mobile-active',
          tier === 'growth'
        );

      });


    mount.appendChild(clone);

  });


  /* ========================================================
     MOBILE PACKAGE TIER SWITCH
  ======================================================== */

  function selectTier(item,tier){

    const tabs =
      item.querySelectorAll(
        '.aw-mobile-tier-tab'
      );


    tabs.forEach(function(tab){

      const active =
        tab.getAttribute('data-tier') === tier;

      tab.setAttribute(
        'aria-selected',
        active ? 'true' : 'false'
      );

    });


    const cards =
      item.querySelectorAll(
        '.aw-mobile-package-mount [data-tier-card]'
      );


    cards.forEach(function(card){

      const active =
        card.getAttribute(
          'data-tier-card'
        ) === tier;

      card.classList.toggle(
        'is-mobile-active',
        active
      );

    });

  }


  /* ========================================================
     CLOSE ACCORDION ITEM
  ======================================================== */

  function closeItem(item){

    const toggle =
      item.querySelector(
        '.aw-accordion-toggle'
      );

    const panel =
      item.querySelector(
        '.aw-accordion-panel'
      );


    if (!toggle || !panel) {
      return;
    }


    toggle.setAttribute(
      'aria-expanded',
      'false'
    );

    panel.hidden = true;

  }


  /* ========================================================
     MOBILE / IPAD ACCORDION
  ======================================================== */

  const items =
    page.querySelectorAll(
      '.aw-accordion-item'
    );


  items.forEach(function(item){

    const toggle =
      item.querySelector(
        '.aw-accordion-toggle'
      );

    const panel =
      item.querySelector(
        '.aw-accordion-panel'
      );


    if (!toggle || !panel) {
      return;
    }


    toggle.addEventListener(
      'click',
      function(){

        const isOpen =
          toggle.getAttribute(
            'aria-expanded'
          ) === 'true';


        /*
          Close every other industry.
        */

        items.forEach(function(other){

          if (other !== item) {
            closeItem(other);
          }

        });


        /*
          Clicking the currently open
          industry closes it.
        */

        if (isOpen) {

          closeItem(item);

          return;

        }


        /*
          Open this exact industry.
          No forced scrolling.
        */

        toggle.setAttribute(
          'aria-expanded',
          'true'
        );

        panel.hidden = false;


        /*
          Reset to Growth.
        */

        selectTier(
          item,
          'growth'
        );

      }
    );


    /*
      STARTER / GROWTH / PRO
    */

    item
      .querySelectorAll(
        '.aw-mobile-tier-tab'
      )
      .forEach(function(tab){

        tab.addEventListener(
          'click',
          function(){

            selectTier(
              item,
              tab.getAttribute(
                'data-tier'
              )
            );

          }
        );

      });

  });


  /* ========================================================
     DESKTOP BACK TO INDUSTRIES
  ======================================================== */

  page.addEventListener(
    'click',
    function(event){

      const back =
        event.target.closest(
          '.aw-back-industries'
        );


      if (!back) {
        return;
      }


      const industries =
        page.querySelector(
          '#industries'
        );


      if (!industries) {
        return;
      }


      event.preventDefault();


      industries.scrollIntoView({
        behavior:'smooth',
        block:'start'
      });

    }
  );

})();
